import { useState, useEffect } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { UPSELL } from "@/lib/upsell";
import { Sparkles, X, ArrowRight } from "lucide-react";

const KEY = "nexx_upsell_dismissed";

export default function UpsellBanner() {
  const { user } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user || localStorage.getItem(KEY) === "1") { setShow(false); return; }
    api.get("/my/ideas")
      .then((r) => setShow((r.data || []).length >= 1))
      .catch(() => setShow(false));
  }, [user]);

  if (!show) return null;

  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };

  return (
    <div className="relative z-30 border-b border-indigo-500/20 bg-gradient-to-r from-indigo-500/12 via-cyan-500/10 to-transparent" data-testid="upsell-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <Sparkles className="w-4 h-4 text-indigo-400 shrink-0" />
        <p className="text-sm text-slate-200 flex-1 min-w-0 truncate">
          <span className="font-semibold text-slate-50">You've validated an idea.</span>{" "}
          <span className="text-slate-400 hidden sm:inline">{UPSELL.tagline}</span>
        </p>
        <a href={UPSELL.url} target="_blank" rel="noreferrer"
          className="shrink-0 inline-flex items-center gap-1.5 text-sm font-semibold px-3.5 py-1.5 rounded-lg bg-indigo-500 hover:bg-indigo-400 text-white transition-colors"
          data-testid="upsell-banner-cta">
          {UPSELL.cta} <ArrowRight className="w-3.5 h-3.5" />
        </a>
        <button onClick={dismiss} className="shrink-0 text-slate-500 hover:text-slate-200" data-testid="upsell-banner-dismiss" aria-label="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
